import { MappingPage } from "Core/Pages/MappingPage";
import { ServiceProvider } from "Service";

export class IfcImportPage extends MappingPage {
    constructor(serviceProvider: ServiceProvider) {
        super("ifc_import", serviceProvider);
    }
}
